import { Record } from "immutable";

export type ReferenceType = {
  text?: string;
  link?: string;
};

const defaultReference: ReferenceType = {
  text: undefined,
  link: undefined
};

export default class Reference extends Record(defaultReference) {}
